class BasePlugin {
  constructor(ctrl) {
      this.ctrl = ctrl;
  }
}

module.exports = BasePlugin;
